/**
 * AbilityTransformToShield.js
 * Implements the 'Transform Bubbles to Shield' enemy ability
 */

import { Game, GameTimer } from "pixi_core";

import { Ability } from "./Ability";
import { Common } from "../Common";
import { Bubble } from "../Bubble";

import { shuffle, BubbleColor, ENEMY_ABILITY_PARTICLE_TRAVEL_TIME } from "../../Constants";

export class AbilityTransformToShield extends Ability {
    /**
     * @public
     * @param {Number} nbBubbles
     * @param {{x: Number, y: Number}} startPos
     * @param {Function} callback
     */
    constructor(nbBubbles, startPos, callback) {
        super();

        /** @private @type {Bubble[]} */
        this._bubbles = [];

        let nonShieldedBubbles = Common.grid.getColoredBubbles(true);
        if (nonShieldedBubbles.length > 0) {
            nonShieldedBubbles = shuffle(nonShieldedBubbles);

            for (let i = 0; i < nonShieldedBubbles.length; ++i) {
                if (i < nbBubbles) {
                    const bubble = nonShieldedBubbles[i];
                    this._bubbles.push(bubble);

                    if (startPos) {
                        Common.particles.createEnemyAbilityParticle(startPos.x, startPos.y, bubble.x, bubble.y, null);
                    }
                } else {
                    break;
                }
            }
        }

        // Spawn bubble instantly if there is no start position (and no particle)
        const delay = startPos && this._bubbles.length > 0 ? ENEMY_ABILITY_PARTICLE_TRAVEL_TIME : 0;

        /** @private @type {GameTimer} */
        this._timerParticlesDelay = Game.windows.getCurrentWindow().createTimer(delay);
        this._timerParticlesDelay.onComplete = () => {
            if (this._bubbles) {
                for (const bubble of this._bubbles) {
                    bubble.changeColor({ color: bubble.color, special: BubbleColor.eSHIELDED }, true);
                }
            }

            if (callback) {
                callback();
            }
        };
    }

    /**
     * @public
     */
    destroy() {
        if (this._timerParticlesDelay) {
            this._timerParticlesDelay.destroy();
            this._timerParticlesDelay = null;
        }

        this._bubbles = null;
    }
}
